import React, { useEffect } from "react";
import { Button } from "react-bootstrap";
// import { searchWord } from '../../helpers/common';
import { SubNav } from "../layout/submenu";
import {
  initialLoadFilterState,
  useLoadHistoryContext,
} from "./context/LoadHistoryContext";
export const maxLoadCountForFilter = 30000;
export const minLoadCountForFilter = 2000;

const LoadHistoryFilter = (props) => {
  const { loadList, weightShortName, tareLoadList } = props;
  const {
    filter,
    setFilter,
    searchText,
    setSearchText,
    filterText,
    setFilterText,
    bulkEditLoadList,
    handleBulkEditLoadSelect,
  } = useLoadHistoryContext();

  const searchInput = React.createRef();

  useEffect(() => {
    if (loadList.length > maxLoadCountForFilter)
      setFilter(initialLoadFilterState);
  }, [loadList]);

  useEffect(() => {
    let filteredList = [...loadList];
    let tareList = [...tareLoadList];

    const checkLimits = (type, id, value) => {
      const range = getFilterRange(type);
      if (!range) return false;
      switch (id) {
        case 1:
          return value < range[0].value;
        case 2:
          return value >= range[0].value && value < range[1].value;
        case 3:
          return value >= range[1].value && value < range[2].value;
        case 4:
          return value >= range[2].value;
        default:
          return false;
      }
    };

    const replacedString = filterText
      .replace(/[*+?^${}()|[\]\\]/g, "\\$&")
      .trim()
      .toLowerCase();
    if (replacedString.trim().length > 0) {
      filteredList = filteredList.filter((entry) =>
        Object.values(entry).some(
          (val) =>
            (typeof val === "string" &&
              val.toLowerCase().includes(replacedString.toLowerCase())) ||
            (Array.isArray(val) &&
              val.some(
                (innerVal) =>
                  typeof innerVal === "string" &&
                  innerVal.toLowerCase().includes(replacedString.toLowerCase())
              ))
        )
      );

      tareList = tareList.filter((entry) =>
        Object.values(entry).some(
          (val) =>
            (typeof val === "string" &&
              val.toLowerCase().includes(replacedString.toLowerCase())) ||
            (Array.isArray(val) &&
              val.some(
                (innerVal) =>
                  typeof innerVal === "string" &&
                  innerVal.toLowerCase().includes(replacedString.toLowerCase())
              ))
        )
      );
    }

    filteredList = filteredList.filter((e) => {
      let isExits = true;
      // if (filterText.trim().length > 0) {
      //     const isSearchTextMatched = value => searchWord(value, filterText);
      //     isExits = isSearchTextMatched(e.crew_name) ||
      //         isSearchTextMatched(e.source_equipment_group_name) || isSearchTextMatched(e.target_equipment_group_name)
      //         || isSearchTextMatched(e.operator_name) || isSearchTextMatched(e.field_geo_shape_name)
      //         || isSearchTextMatched(e.offload_geo_shape_name) || isSearchTextMatched(e.offload_geo_storage_location_name) || isSearchTextMatched(e.pipe)
      //         || isSearchTextMatched(e.variety) /* || isSearchTextMatched(e.load_params) */
      //     if (!isExits) return false;

      //     const replacedString = filterText.replace(/[*+?^${}()|[\]\\]/g, '\\$&').trim().toLowerCase();

      //     filteredList = filteredList.filter(entry =>
      //         Object.values(e).some(val =>
      //             (typeof val === 'string' && val.toLowerCase().includes(replacedString.toLowerCase())) ||
      //             (Array.isArray(val) && val.some(innerVal =>
      //                 typeof innerVal === 'string' && innerVal.toLowerCase().includes(replacedString.toLowerCase())
      //             ))
      //         )
      //     );
      // }

      for (const item of filter.duration) {
        isExits = checkLimits("seconds", item.id, e.load_seconds);
        if (isExits) break;
      }
      if (!isExits) return false;

      for (const item of filter.loadWeight) {
        isExits = checkLimits(weightShortName, item.id, e.load_capacity);
        if (isExits) break;
      }
      if (!isExits) return false;

      for (const item of filter.loadGrossWeight) {
        isExits = checkLimits(
          weightShortName,
          item.id,
          e.estimated_load_capacity
        );
        if (isExits) break;
      }
      if (!isExits) return false;

      for (const item of filter.status) {
        isExits = item.id === 1 ? e.approved : !e.approved;
        if (isExits) break;
      }
      if (!isExits) return false;

      return isExits;
    });

    // For Tare History Filters
    tareList = tareList.filter((e) => {
      let isExits = true;
      for (const item of filter.duration) {
        isExits = checkLimits("seconds", item.id, e.load_seconds);
        if (isExits) break;
      }
      if (!isExits) return false;

      for (const item of filter.loadWeight) {
        isExits = checkLimits(weightShortName, item.id, e.load_capacity);
        if (isExits) break;
      }
      if (!isExits) return false;

      for (const item of filter.loadGrossWeight) {
        isExits = checkLimits(
          weightShortName,
          item.id,
          e.estimated_load_capacity
        );
        if (isExits) break;
      }
      if (!isExits) return false;

      for (const item of filter.status) {
        isExits = item.id === 1 ? e.approved : !e.approved;
        if (isExits) break;
      }
      if (!isExits) return false;

      return isExits;
    });

    if (filter.fieldShape.length > 0) {
      filteredList = filteredList.filter((item) =>
        filter.fieldShape
          .map((shape) => shape.id)
          .includes(item.field_geo_shape_uuid)
      );
      tareList = tareList.filter((item) =>
        filter.fieldShape
          .map((shape) => shape.id)
          .includes(item.field_geo_shape_uuid)
      );
    }

    if (filter.offloadSite.length > 0) {
      filteredList = filteredList.filter((item) =>
        filter.offloadSite
          .map((shape) => shape.id)
          .includes(item.offload_geo_shape_uuid)
      );
      tareList = tareList.filter((item) =>
        filter.offloadSite
          .map((shape) => shape.id)
          .includes(item.offload_geo_shape_uuid)
      );
    }

    if (filter.storage.length > 0) {
      filteredList = filteredList.filter((item) =>
        filter.storage
          .map((shape) => shape.id)
          .includes(item.offload_geo_storage_location_uuid)
      );
      tareList = tareList.filter((item) =>
        filter.storage
          .map((shape) => shape.id)
          .includes(item.offload_geo_storage_location_uuid)
      );
    }

    if (filter.pipe.length > 0) {
      filteredList = filteredList.filter((item) =>
        filter.pipe.map((pipe) => pipe.id).includes(item.pipe)
      );
      tareList = tareList.filter((item) =>
        filter.pipe.map((pipe) => pipe.id).includes(item.pipe)
      );
    }

    if (filter.targetEg.length > 0) {
      filteredList = filteredList.filter((item) =>
        filter.targetEg
          .map((eg) => eg.id)
          .includes(item.target_equipment_group_uuid)
      );
      tareList = tareList.filter((item) =>
        filter.targetEg
          .map((eg) => eg.id)
          .includes(item.target_equipment_group_uuid)
      );
    }

    if (filter.sourceEg.length > 0) {
      filteredList = filteredList.filter((item) =>
        filter.sourceEg
          .map((eg) => eg.id)
          .includes(item.source_equipment_group_uuid)
      );

      tareList = tareList.filter((item) =>
        filter.sourceEg
          .map((eg) => eg.id)
          .includes(item.source_equipment_group_uuid)
      );
    }

    if (filter.crew.length > 0) {
      filteredList = filteredList.filter((item) =>
        filter.crew.map((crew) => crew.id).includes(item.crew_uuid)
      );
      tareList = tareList.filter((item) =>
        filter.crew.map((crew) => crew.id).includes(item.crew_uuid)
      );
    }

    if (filter.crop.length > 0) {
      filteredList = filteredList.filter((item) =>
        filter.crop.map((crop) => crop.id).includes(item.crop_name)
      );
      tareList = tareList.filter((item) =>
        filter.crop.map((crop) => crop.id).includes(item.crop_name)
      );
    }
    if (filter.variety.length > 0) {
      filteredList = filteredList.filter((item) =>
        filter.variety.map((it) => it.id).includes(item.variety)
      );
      tareList = tareList.filter((item) =>
        filter.variety.map((it) => it.id).includes(item.variety)
      );
    }

    if (filter.vendor.length > 0) {
      filteredList = filteredList.filter((item) =>
        filter.vendor
          .map((vendor) => vendor.label)
          .includes(item.target_equipment_vendor_name)
      );
      tareList = tareList.filter((item) =>
        filter.vendor
          .map((vendor) => vendor.label)
          .includes(item.target_equipment_vendor_name)
      );
    }

    props.setFilteredList(filteredList);
    props.setTareHistoryFilter(tareList);

    if (bulkEditLoadList.length > 0) {
      handleBulkEditLoadSelect(filteredList, true, true);
    }
  }, [
    loadList,
    filterText,
    filter.duration,
    filter.loadWeight,
    filter.status,
    filter.fieldShape,
    filter.offloadSite,
    filter.storage,
    filter.pipe,
    filter.targetEg,
    filter.crew,
    filter.crop,
    filter.vendor,
    filter.loadGrossWeight,
    filter.variety,
    filter.sourceEg,
  ]);

  const getFilterRange = (keyName) => {
    switch (keyName) {
      case "seconds":
        return [
          { value: 60, label: "1m" },
          { value: 600, label: "10m" },
          { value: 3600, label: "1hr" },
        ];
      case "lbs":
        return [
          { value: 25000, label: "25000" },
          { value: 50000, label: "50000" },
          { value: 100000, label: "100000" },
        ];
      case "sacks":
        return [
          { value: 250, label: "250" },
          { value: 500, label: "500" },
          { value: 1000, label: "1000" },
        ];
      case "tons":
      case "tonnes":
        return [
          { value: 15, label: "15" },
          { value: 30, label: "30" },
          { value: 50, label: "50" },
        ];
      case "approve":
        return [
          { value: true, label: "Approved" },
          { value: false, label: "Not Approved" },
        ];
      default:
        return null;
    }
  };

  return (
    <>
      <div className="search-container d-flex m-0">
        <SubNav.SearchBox
          ref={searchInput}
          placeholder="Search for crew, equipment group, operator, field, offload site, storage, pipe"
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          onClear={() => {
            setSearchText("");
            setFilterText("");
          }}
        />
        <Button
          size="sm"
          onClick={() => setFilterText(searchText)}
          disabled={searchText === filterText}
        >
          Search
        </Button>
      </div>
    </>
  );
};

export default LoadHistoryFilter;